var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';

var defaultComparator = function defaultComparator(a, b) {
  return a === b;
};

var match = function match(bits, mask) {
  return Object.keys(mask).every(function (key) {
    return (bits.rules[key] || defaultComparator)(mask[key], bits.bits[key], key);
  });
};

function find(array, predicate) {
  return array.filter(predicate)[0];
}

var merge = function merge(a, key, c) {
  return __assign({}, a[key], c);
};

var getProps = function getProps(_a) {
  var bits = _a.bits,
      children = _a.children,
      mask = __rest(_a, ["bits", "children"]);

  return mask;
};

function createMaskedProvider(initial, rules) {
  if (rules === void 0) {
    rules = {};
  }

  var context = React.createContext({
    bits: initial,
    rules: rules
  });
  var Consumer = context.Consumer;
  var empty = {
    value: {},
    rules: {}
  };

  var Provider = function Provider(_a) {
    var bits = _a.bits,
        _b = _a.rules,
        rules = _b === void 0 ? {} : _b,
        children = _a.children;
    return React.createElement(Consumer, null, function (value) {
      if (value === void 0) {
        value = empty;
      }

      return React.createElement(context.Provider, {
        value: {
          bits: merge(value, 'value', bits),
          rules: merge(value, 'rules', rules)
        }
      }, children);
    });
  };

  var Case = function Case(props) {
    var bits = props.bits,
        children = props.children;
    var mask = getProps(props);

    if (bits) {
      return match({
        bits: bits,
        rules: {}
      }, mask) ? children : null;
    }

    return React.createElement(Consumer, null, function (value) {
      return match(value, mask) ? children : null;
    });
  };

  var Read = function Read(props) {
    var bits = props.bits,
        children = props.children;
    var mask = getProps(props);

    if (bits) {
      return children(match({
        bits: bits,
        rules: {}
      }, mask), bits);
    }

    return React.createElement(Consumer, null, function (value) {
      return children(match(value, mask), value.bits);
    });
  };

  var Default = function Default(_a) {
    var children = _a.children;
    return children;
  };

  var CaseType = React.createElement(Case, null).type;
  var DefaultType = React.createElement(Default, null).type;

  var pickCase = function pickCase(mask, children) {
    return find(children, function (child) {
      return typeof child === 'object' && CaseType === child.type && match(mask, getProps(child.props));
    }) || find(children, function (child) {
      return typeof child === 'object' && DefaultType === child.type;
    }) || null;
  };

  var Switch = function Switch(_a) {
    var children = _a.children,
        bits = _a.bits;
    return bits ? pickCase({
      values: bits
    }, React.Children.toArray(children)) : React.createElement(Consumer, null, function (mask) {
      return pickCase(mask, React.Children.toArray(children));
    });
  };

  return {
    Provider: Provider,
    Switch: Switch,
    Case: Case,
    Read: Read,
    Default: Default
  };
}

export default createMaskedProvider;